import FlightsHeader from './../../components/component/header/flights_header.jsx';

import FooterFlights from './../../components/component/footer/footer_flights.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';


function Flights() {
    return (
        <main>
            <FlightsHeader />

            <FooterFlights />
            <LaptopFooter />
        </main>
    );
}

export default Flights;

